import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreManageCardsModal as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    addCardButtonText: 'Add a card',
    getTitle: () => <>Your available cards.</>,
    getSubTitle: (onFaqClick) => (
      <>
        <span>We use your linked card to track your qualifying purchases. We'll never charge your card.</span>{' '}
        <button className="mn_basicButton" onClick={onFaqClick}>Learn more.</button>
      </>
    ),
    shouldShowSupportedCards: false,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
